export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/74cc88c7571ddfe8037db442e45677ad.svg";